export type PackagingType = 'box' | 'jacket' | 'card' | 'wrap' | 'other';

export const PACKAGING_TYPES: PackagingType[] = ['box', 'jacket', 'card', 'wrap', 'other'];

// Packaging is counted in whole units and consumed one complete set per parcel
// — unlike oils, which are consumed in ml against a formula.
export interface PackagingItem {
  id: string;
  item_name: string;
  item_type: PackagingType | null;
  quantity: number;
  unit_cost: number | null;
  reorder_level: number;
  last_restocked_at: string | null;
  created_at: string;
  notes: string | null;
  /** Derived server-side: out (0) → low (≤ reorder level) → ok. */
  status: 'ok' | 'low' | 'out';
}
